import React from 'react'

interface ShieldKeyIconProps {
  className?: string
  size?: number
  color?: string
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function ShieldKeyIcon({
  className = '',
  size = 24,
  color = 'white'
}: ShieldKeyIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M18.8564 7.18821C18.7698 6.57944 18.3874 6.04444 17.8252 5.76878L12.8257 3.3181C12.305 3.06282 11.6955 3.06285 11.1748 3.3181L6.17383 5.76878C5.53167 6.08384 5.12499 6.73804 5.125 7.45335V13.4665L5.13525 13.7331C5.23472 15.0649 6.06982 16.4076 7.31348 17.6633C8.61525 18.9777 10.2044 20.0331 11.2964 20.6794C11.7355 20.9393 12.265 20.9393 12.7041 20.6794C13.7959 20.0331 15.384 18.9774 16.6855 17.6633C17.9293 16.4075 18.7657 15.0649 18.8652 13.7331L18.8755 13.4665V7.45335L18.8564 7.18821ZM21.1255 13.4665L21.1094 13.8972C20.9533 16.0247 19.6633 17.8553 18.2852 19.2468C16.977 20.5676 15.4555 21.6275 14.314 22.3347L13.8496 22.6159C12.7754 23.2517 11.4707 23.2923 10.3677 22.7361L10.1494 22.6159C8.98263 21.9253 7.21003 20.7559 5.71533 19.2468C4.33719 17.8553 3.04714 16.0247 2.89111 13.8972L2.875 13.4665V7.45335C2.87498 5.87942 3.77046 4.44176 5.18359 3.74876L10.1846 1.29808L10.4014 1.19847C11.4966 0.737949 12.7422 0.771607 13.8159 1.29808L18.8154 3.74876C20.2287 4.44169 21.1255 5.87936 21.1255 7.45335V13.4665Z"/>
<path d="M12.8755 9.99952C12.8752 9.5165 12.4826 9.12501 11.9995 9.12501C11.5166 9.12528 11.1253 9.51666 11.125 9.99952C11.125 10.4826 11.5165 10.8752 11.9995 10.8755C12.4828 10.8755 12.8755 10.4828 12.8755 9.99952ZM15.1255 9.99952C15.1255 11.3286 14.2942 12.4613 13.1245 12.9131V15.9995C13.1245 16.6208 12.6208 17.1245 11.9995 17.1245C11.3784 17.1243 10.8745 16.6207 10.8745 15.9995V12.9116C9.70556 12.4595 8.875 11.3281 8.875 9.99952C8.87526 8.27402 10.274 6.87528 11.9995 6.87501C13.7252 6.87501 15.1252 8.27386 15.1255 9.99952Z"/>
    </svg>
  )
}